import { j as o } from "../../jsx-runtime-C5mzlN2N.js";
import t from "styled-components";
import { sideBarItemStyles as l, backdropAnimationStyles as v, contentAnimationStyles as b } from "./styles.es.js";
import { forwardRef as y } from "react";
import { I as p } from "../../CheckIcon-XCAywhAi.js";
import "../Icon/countryVariants.es.js";
import "../../styles-DaQVIHg4.js";
import { T as w } from "../../Typography-CGn3dGWy.js";
import { u as f, S as $ } from "../../hooks-CEtTXk08.js";
import { L as h } from "../../Logo-C7ffI-Ve.js";
import "../Theme/themes.es.js";
import { c as j, r as k } from "../../palettes-Bw24w7AF.js";
import { getPaletteBackground as c, getZIndexes as B, getPaletteForeground as m, getPaletteBase as S, getEffects as x, getSpacings as d, getPaletteBorder as C } from "../Theme/utils.es.js";
import { useMediaQuery as D } from "../Theme/hooks.es.js";
import "../../CssBaseline-Bp4jdUgb.js";
import { u as I } from "../../useDisclose-DpzoV9h_.js";
import "@floating-ui/react-dom";
import { createPortal as P } from "react-dom";
import { I as z } from "../../IconButton-g0G4rvcV.js";
import { DisclosureButton as O, DisclosurePanel as L, Disclosure as M } from "@headlessui/react";
const A = t.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1 0 0;
  gap: 12px;

  min-width: 0;

  span {
    flex: 1 0 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  };
`, u = y(function(r, n) {
  const {
    text: a,
    icon: s,
    className: i,
    onClick: g
  } = r;
  return /* @__PURE__ */ o.jsxs(
    A,
    {
      className: i,
      ref: n,
      onClick: g,
      children: [
        s && /* @__PURE__ */ o.jsx(
          p,
          {
            width: 20,
            height: 20,
            ...s
          }
        ),
        /* @__PURE__ */ o.jsx(w, { variant: "text", size: "md", weight: "semibold", as: "span", children: a })
      ]
    }
  );
}), N = t.div`
  ${l.root}
  
  &:hover {
    ${l.active}
  }
    
  &.active {
    ${l.active}
  }
  
`, bo = (e) => {
  const {
    text: r,
    icon: n,
    className: a
  } = e, { mobileDisclose: s } = f();
  return /* @__PURE__ */ o.jsx(
    N,
    {
      className: a,
      onClick: s.onClose,
      children: /* @__PURE__ */ o.jsx(
        u,
        {
          text: r,
          icon: n
        }
      )
    }
  );
}, R = t.div`
  width: 100%;
  height: 64px;

  display: flex;
  flex-direction: row;
  align-items: center;

  box-sizing: border-box;
  
  background-color: ${c("primary.default")};
`, T = t.div`
  overflow: hidden;
  position: fixed;
  background-color: transparent;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  z-index: ${B("drawer")};

  &[data-is-open='false'] {
    transition-property: visibility;
    transition-delay: 150ms;
    visibility: hidden;
  }
`, E = t.div`
  position: relative;
`, F = t.button`
  pointer-events: auto;

  position: absolute;
  top: 12px;
  right: 8px;
  z-index: 1;

  width: 40px;
  height: 40px;
  padding: 8px;

  border-radius: 8px;
  border-width: 0;
  border-style: none;

  color: ${m("white")};
  background-color: ${S("transparent")};

  &:hover {
    cursor: pointer;
    color: ${m("white")};
    background-color: ${(e) => j(0.9, c("primary.default")(e))};
  }

  > svg {
    opacity: 0.7;
  }

  &[data-is-open='false'] {
    display: none;
  }
`, Q = t.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: ${(e) => k(c("overlay")(e), 0.7)};
  backdrop-filter: ${(e) => `blur(${x("blur.sm")(e)})`};
  -webkit-backdrop-filter: ${(e) => `blur(${x("blur.sm")(e)})`};
  
  ${v}
`, Z = t.div`
  position: relative;
  height: 100vh;
  width: calc(100vw - 64px);
  pointer-events: all;
  display: flex;
  flex-flow: column;
  align-items: stretch;
  gap: 16px;
  
  background-color: ${c("primary.default")};
  box-shadow: ${x("shadows.xl")};

  ${b}
`, q = t.div`
  display: flex;
  flex: 1;
  flex-flow: column;
  align-items: stretch;
  overflow-y: auto;
  padding: 4px 8px;
  gap: 4px;
`, G = t(z)`
  margin-left: auto;
`, H = t(h)`
  padding: ${d("xl")} ${d("xl")} 0 ${d("xl")}; 
`, J = (e) => {
  const {
    children: r,
    className: n,
    footer: a,
    logo: s
  } = e, {
    mobileDisclose: i
  } = f();
  return /* @__PURE__ */ o.jsxs(R, { className: n, children: [
    /* @__PURE__ */ o.jsx(
      G,
      {
        size: "2xl",
        variant: "ghost",
        color: "gray",
        onClick: i.onOpen,
        children: /* @__PURE__ */ o.jsx(p, { variant: "menu" })
      }
    ),
    P(/* @__PURE__ */ o.jsx(T, { "data-is-open": i.isOpen, children: /* @__PURE__ */ o.jsxs(E, { children: [
      /* @__PURE__ */ o.jsx(
        F,
        {
          "data-is-open": i.isOpen,
          onClick: i.onClose,
          children: /* @__PURE__ */ o.jsx(p, { variant: "close" })
        }
      ),
      /* @__PURE__ */ o.jsx(
        Q,
        {
          "data-is-open": i.isOpen,
          onClick: i.onClose
        }
      ),
      /* @__PURE__ */ o.jsxs(Z, { "data-is-open": i.isOpen, children: [
        /* @__PURE__ */ o.jsx(H, { variant: s }),
        /* @__PURE__ */ o.jsx(q, { children: r }),
        a
      ] })
    ] }) }), document.body)
  ] });
}, K = t.nav`
  width: 312px;
  height: 100vh;

  background-color: ${c("primary.default")};
  
  display: flex;
  flex-flow: column;
  
  overflow: hidden;
  
  > *:first-child {
    padding: 32px 20px 24px 20px;
  }

  div.main {
    overflow-y: auto;

    padding: 4px 16px;

    display: flex;
    flex: 1;
    flex-flow: column;
    align-items: stretch;

    gap: 4px;
  }
`, U = t.div`
  border-top: 1px solid ${C("secondary")};
  padding: ${d("xl")};
`, yo = (e) => {
  const {
    logo: r,
    children: n
  } = e, a = D("mobile"), s = I(), i = e.footer ? /* @__PURE__ */ o.jsx(U, { children: e.footer }) : void 0;
  return /* @__PURE__ */ o.jsx(
    $.Provider,
    {
      value: {
        mobileDisclose: s
      },
      children: a ? /* @__PURE__ */ o.jsx(
        J,
        {
          logo: r,
          footer: i,
          children: n
        }
      ) : /* @__PURE__ */ o.jsxs(K, { children: [
        /* @__PURE__ */ o.jsx(h, { variant: r }),
        /* @__PURE__ */ o.jsx("div", { className: "main", children: n }),
        i
      ] })
    }
  );
}, V = t(O)`
  ${l.root}
  
  &:hover {
    ${l.active}
  }
  
  ${(e) => e.$isActive ? l.active : ""}
`, W = t(L)`
  padding-left: ${d("4xl")};
`, X = t.div`
  display: contents;
`, wo = (e) => {
  const {
    text: r,
    icon: n,
    children: a,
    defaultOpen: s
  } = e;
  return /* @__PURE__ */ o.jsx(M, { defaultOpen: s, children: (i) => /* @__PURE__ */ o.jsxs(X, { children: [
    /* @__PURE__ */ o.jsxs(
      V,
      {
        $isActive: i.open,
        children: [
          /* @__PURE__ */ o.jsx(
            u,
            {
              text: r,
              icon: n
            }
          ),
          /* @__PURE__ */ o.jsx(
            p,
            {
              variant: i.open ? "chevron-up" : "chevron-down",
              height: 20,
              width: 20
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ o.jsx(W, { children: a })
  ] }) });
};
export {
  bo as SideBarItem,
  u as SideBarLabel,
  wo as SideBarParentItem,
  yo as default
};
